/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7TreeGlobalVariablesDashboardsGetByDashboardIdParams,
  IntegratedDashboardTreeGlobalVariableResponse,
  SuccessResponse,
  TreeTagResponse,
  _RequestBody,
  _Response,
  _UpdateRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 대시보드별 트리 글로벌 변수 목록 조회
 */
export const getV7TreeGlobalVariablesDashboardsByDashboardId = (
  dashboardId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);

  return customAxiosInstance<_Response[]>(
    { url: `/api/v7/tree-global-variables/dashboards/${dashboardId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7TreeGlobalVariablesDashboardsByDashboardIdQueryKey = (
  dashboardId?: MaybeRef<number>,
) => {
  return ['api', 'v7', 'tree-global-variables', 'dashboards', dashboardId] as const;
};

export const getGetV7TreeGlobalVariablesDashboardsByDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TreeGlobalVariablesDashboardsByDashboardIdQueryKey(dashboardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>
  > = ({ signal }) =>
    getV7TreeGlobalVariablesDashboardsByDashboardId(dashboardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(dashboardId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>,
    TError,
    TData
  >;
};

export type GetV7TreeGlobalVariablesDashboardsByDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>
>;
export type GetV7TreeGlobalVariablesDashboardsByDashboardIdQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드별 트리 글로벌 변수 목록 조회
 */

export function useGetV7TreeGlobalVariablesDashboardsByDashboardId<
  TData = Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TreeGlobalVariablesDashboardsByDashboardIdQueryOptions(
    dashboardId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 트리 글로벌 변수 생성
 */
export const postV7TreeGlobalVariablesDashboardsByDashboardId = (
  dashboardId: MaybeRef<number>,
  _requestBody: MaybeRef<_RequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  _requestBody = unref(_requestBody);

  return customAxiosInstance<_Response>(
    {
      url: `/api/v7/tree-global-variables/dashboards/${dashboardId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: _requestBody,
      signal,
    },
    options,
  );
};

export const getPostV7TreeGlobalVariablesDashboardsByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>,
    TError,
    { dashboardId: number; data: BodyType<_RequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<_RequestBody> },
  TContext
> => {
  const mutationKey = ['postV7TreeGlobalVariablesDashboardsByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>,
    { dashboardId: number; data: BodyType<_RequestBody> }
  > = (props) => {
    const { dashboardId, data } = props ?? {};

    return postV7TreeGlobalVariablesDashboardsByDashboardId(dashboardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7TreeGlobalVariablesDashboardsByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>
>;
export type PostV7TreeGlobalVariablesDashboardsByDashboardIdMutationBody = BodyType<_RequestBody>;
export type PostV7TreeGlobalVariablesDashboardsByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary 트리 글로벌 변수 생성
 */
export const usePostV7TreeGlobalVariablesDashboardsByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>,
      TError,
      { dashboardId: number; data: BodyType<_RequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesDashboardsByDashboardId>>,
  TError,
  { dashboardId: number; data: BodyType<_RequestBody> },
  TContext
> => {
  const mutationOptions =
    getPostV7TreeGlobalVariablesDashboardsByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드별 트리 글로벌 변수 조회
 */
export const getV7TreeGlobalVariablesDashboardsGetByDashboardId = (
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7TreeGlobalVariablesDashboardsGetByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  params = unref(params);

  return customAxiosInstance<IntegratedDashboardTreeGlobalVariableResponse>(
    {
      url: `/api/v7/tree-global-variables/dashboards/${dashboardId}/get`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryKey = (
  dashboardId?: MaybeRef<number>,
  params?: MaybeRef<GetV7TreeGlobalVariablesDashboardsGetByDashboardIdParams>,
) => {
  return [
    'api',
    'v7',
    'tree-global-variables',
    'dashboards',
    dashboardId,
    'get',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7TreeGlobalVariablesDashboardsGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryKey(
    dashboardId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>
  > = ({ signal }) =>
    getV7TreeGlobalVariablesDashboardsGetByDashboardId(dashboardId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(dashboardId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>,
    TError,
    TData
  >;
};

export type GetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>
>;
export type GetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryError = ErrorType<unknown>;

/**
 * @summary 대시보드별 트리 글로벌 변수 조회
 */

export function useGetV7TreeGlobalVariablesDashboardsGetByDashboardId<
  TData = Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7TreeGlobalVariablesDashboardsGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7TreeGlobalVariablesDashboardsGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TreeGlobalVariablesDashboardsGetByDashboardIdQueryOptions(
    dashboardId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 트리 변수 태그 조회 (설정)
 */
export const postV7TreeGlobalVariablesTags = (
  _requestBody: MaybeRef<_RequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  _requestBody = unref(_requestBody);

  return customAxiosInstance<TreeTagResponse>(
    {
      url: `/api/v7/tree-global-variables/tags`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: _requestBody,
      signal,
    },
    options,
  );
};

export const getPostV7TreeGlobalVariablesTagsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>,
    TError,
    { data: BodyType<_RequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>,
  TError,
  { data: BodyType<_RequestBody> },
  TContext
> => {
  const mutationKey = ['postV7TreeGlobalVariablesTags'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>,
    { data: BodyType<_RequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7TreeGlobalVariablesTags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7TreeGlobalVariablesTagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>
>;
export type PostV7TreeGlobalVariablesTagsMutationBody = BodyType<_RequestBody>;
export type PostV7TreeGlobalVariablesTagsMutationError = ErrorType<unknown>;

/**
 * @summary 트리 변수 태그 조회 (설정)
 */
export const usePostV7TreeGlobalVariablesTags = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>,
      TError,
      { data: BodyType<_RequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7TreeGlobalVariablesTags>>,
  TError,
  { data: BodyType<_RequestBody> },
  TContext
> => {
  const mutationOptions = getPostV7TreeGlobalVariablesTagsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 트리 글로벌 변수 수정
 */
export const putV7TreeGlobalVariablesById = (
  id: MaybeRef<number>,
  _updateRequest: MaybeRef<_UpdateRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  id = unref(id);
  _updateRequest = unref(_updateRequest);

  return customAxiosInstance<_Response>(
    {
      url: `/api/v7/tree-global-variables/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: _updateRequest,
    },
    options,
  );
};

export const getPutV7TreeGlobalVariablesByIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>,
    TError,
    { id: number; data: BodyType<_UpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>,
  TError,
  { id: number; data: BodyType<_UpdateRequest> },
  TContext
> => {
  const mutationKey = ['putV7TreeGlobalVariablesById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>,
    { id: number; data: BodyType<_UpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putV7TreeGlobalVariablesById(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV7TreeGlobalVariablesByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>
>;
export type PutV7TreeGlobalVariablesByIdMutationBody = BodyType<_UpdateRequest>;
export type PutV7TreeGlobalVariablesByIdMutationError = ErrorType<unknown>;

/**
 * @summary 트리 글로벌 변수 수정
 */
export const usePutV7TreeGlobalVariablesById = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>,
      TError,
      { id: number; data: BodyType<_UpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof putV7TreeGlobalVariablesById>>,
  TError,
  { id: number; data: BodyType<_UpdateRequest> },
  TContext
> => {
  const mutationOptions = getPutV7TreeGlobalVariablesByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 트리 글로벌 변수 삭제
 */
export const deleteV7TreeGlobalVariablesById = (
  id: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  id = unref(id);

  return customAxiosInstance<SuccessResponse>(
    { url: `/api/v7/tree-global-variables/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteV7TreeGlobalVariablesByIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteV7TreeGlobalVariablesById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteV7TreeGlobalVariablesById(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV7TreeGlobalVariablesByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>
>;

export type DeleteV7TreeGlobalVariablesByIdMutationError = ErrorType<unknown>;

/**
 * @summary 트리 글로벌 변수 삭제
 */
export const useDeleteV7TreeGlobalVariablesById = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV7TreeGlobalVariablesById>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteV7TreeGlobalVariablesByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
